// Подсветка усика «Траекторий по HSI» при наведении — настройка судоводителя.
//
// Усиков в кадре сотни, они пересекаются: проследить глазом ОДИН путь от origin
// до «сейчас» не выходит. Наведение мыши обводит один усик целиком белым
// ореолом (стиль слоя — hsiDrift.ts).
//
// Настройка нужна, потому что приём не бесплатен: карта под курсором меняется
// сама, а на плотном поле это мешает тем, кто снимает с неё координаты. По
// умолчанию ВКЛЮЧЕНА (решение владельца 2026-08-17): подсветка помогает читать
// карту и ничего в ней не значит — искать её в настройках не должно быть нужно.
//
// Хранится в localStorage этого браузера — как тема и густота сетки
// (graticuleDensity.ts): своя на машине, без похода на сервер. Живёт вне
// React-дерева: карта и страница настроек — разные маршруты, и открытая карта
// обязана узнать о смене сразу, а не после перезагрузки.

import { useSyncExternalStore } from 'react'

const DEFAULT = true
const KEY = 'cabinet.hsiDriftHighlight'

/** Ключи каталога перевода — подпись тумблера и пояснение под ним. */
export const HIGHLIGHT_LABEL_KEY = 'settings.map.hsiHighlight'
export const HIGHLIGHT_HINT_KEY = 'settings.map.hsiHighlightHint'

/** Значение → строка хранилища. Пара к parseHighlight: кодировка написана один
 *  раз, иначе «выключено» однажды сохранилось бы неузнаваемым. */
export function storedHighlight(on: boolean): string {
  return on ? '1' : '0'
}

/** Строка хранилища → значение. Терпимо к чужому: localStorage переживает
 *  выкладки. Непонятное читается как умолчание — молча погасшая подсветка
 *  выглядела бы поломкой карты, а не настройкой. */
export function parseHighlight(raw: string | null | undefined): boolean {
  if (raw === storedHighlight(false)) return false
  if (raw === storedHighlight(true)) return true
  return DEFAULT
}

export function getHsiHighlight(): boolean {
  try {
    return parseHighlight(localStorage.getItem(KEY))
  } catch {
    return DEFAULT
  }
}

const listeners = new Set<() => void>()

export function setHsiHighlight(on: boolean): void {
  try {
    localStorage.setItem(KEY, storedHighlight(on))
  } catch {
    /* приватный режим — настройка просто не переживёт вкладку */
  }
  listeners.forEach(fn => fn())
}

function subscribe(fn: () => void): () => void {
  listeners.add(fn)
  return () => {
    listeners.delete(fn)
  }
}

/** Настройка в React. Карта узнаёт о смене сразу: подписка живёт вне дерева,
 *  поэтому переход между маршрутами ей не мешает. */
export function useHsiHighlight(): boolean {
  return useSyncExternalStore(subscribe, getHsiHighlight, () => DEFAULT)
}
